interface EmptyStateProps {
  variant: 'no-orders' | 'no-results';
  productsRoute: string;
}

export function EmptyState({ variant, productsRoute }: EmptyStateProps) {
  const isNoOrders = variant === 'no-orders';

  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center md:py-20">
      <div className="mb-6 h-20 w-20 text-gray-300 md:h-24 md:w-24">
        {isNoOrders ? (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-full w-full">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-full w-full">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
          </svg>
        )}
      </div>

      <h2 className="mb-2 text-xl font-semibold text-gray-800 md:text-2xl">
        {isNoOrders ? 'Todavía no hiciste ninguna compra' : 'No se encontraron compras'}
      </h2>

      <p className="mb-6 max-w-xs text-[15px] text-gray-500 md:text-base">
        {isNoOrders
          ? '¿Querés realizar tu primera compra?'
          : 'Probá con otras fechas o limpiá los filtros'
        }
      </p>

      {isNoOrders && (
        <a
          href={productsRoute}
          className="inline-flex h-11 items-center justify-center rounded-lg bg-green-600 px-6 text-[15px] font-semibold text-white no-underline transition-colors hover:bg-green-700 hover:text-white"
        >
          Ir al mercado y empezar a comprar
        </a>
      )}
    </div>
  );
}
